import { IntlShape } from 'react-intl'
import { create, each, enforce, group, test } from 'vest'
import {
  ProgressiveDiscount,
  ProgressiveDiscountBenefit,
  ProgressiveDiscountConfig,
} from '../../../../../../typings'
import messages from '../messages'

export const name = ProgressiveDiscount.Benefit

export function validationSuite(intl: IntlShape) {
  return create((benefit: ProgressiveDiscountBenefit) => {
    const { $t } = intl
    const { validation } = messages

    const isUnique = (
      fieldName: keyof ProgressiveDiscountConfig,
      fieldValue: number
    ) =>
      benefit.filter((interval) => interval[fieldName] === fieldValue).length ==
      1

    group('benefit', () => {
      each(benefit, (interval, index) => {
        const { quantity, discount } = interval

        test(
          `${name}.${index}.quantity`,
          $t(validation.greaterThan, { value: 0 }),
          () => {
            enforce(quantity).gt(0)
          }
        )

        test(
          `${name}.${index}.discount`,
          $t(validation.greaterThan, { value: 0 }),
          () => {
            enforce(discount).gt(0)
          }
        )

        test(
          `${name}.${index}.discount`,
          $t(validation.lessThanOrEquals, { value: 100 }),
          () => {
            enforce(discount).lte(100)
          }
        )

        test(`${name}.${index}.quantity`, $t(validation.duplicated), () => {
          enforce(isUnique('quantity', quantity)).isTruthy()
        })

        test(`${name}.${index}.discount`, $t(validation.duplicated), () => {
          enforce(isUnique('discount', discount)).isTruthy()
        })
      })
    })
  })
}
